import Spinner from 'components/Spinner'
import Table from 'components/Table'
import React, { useEffect, useState } from 'react'
import { useAppDispatch, useAppState } from 'store'
import { appointmentActions } from 'store/slices/appointments/appointments.slice'
import { AppointmentProps } from './Appointments.props'
import { AppointmentsContainer } from './Appointments.styled'
import AppointmentsItem from './AppointmentsItem'

const APPOINTMENT_LIST_HEADER: string[] = [
  'Date',
  'Time',
  'Description',
  // 'Options',
]

const Appointments = ({ locationId, clientId }: AppointmentProps) => {
  const {
    totalAppointments,
    loading,
    currentPage,
    userAppointments,
  } = useAppState(state => state.appointments)
  const dispatch = useAppDispatch()
  const [tableLoading, setTableLoading] = useState<boolean>(false)

  useEffect(() => {
    if (!userAppointments || userAppointments.length === 0) {
      dispatch(
        appointmentActions.getUserAppointments({
          locationId: locationId,
          userId: clientId,
          limit: 10,
          page: currentPage,
        })
      )
    }
  }, [])

  useEffect(() => {
    if (loading === 'loading') {
      setTableLoading(true)
    }
    if (loading === 'succeeded') {
      setTableLoading(false)
    }
  }, [loading])

  return (
    <AppointmentsContainer>
      {tableLoading ? (
        <Spinner loading={tableLoading} />
      ) : (
        <Table
          header={APPOINTMENT_LIST_HEADER}
          styles={{ width: '100%' }}
          pagination
          totalCount={totalAppointments}
          currentPage={currentPage}>
          {userAppointments &&
            userAppointments.map(appointment => (
              <AppointmentsItem
                appointment={appointment}
                key={appointment.id}
              />
            ))}
        </Table>
      )}
    </AppointmentsContainer>
  )
}

export default Appointments
